import ChitChatIcon from "@features/messages/components/ChitChatIcon";
import theme from "@shared/utils/themeColors";
import ThemeToggle from "../../../components/ThemeToggle";
import DropdownHelp from "../dropdown/DropdownHelp";
import { NotificationsDropdown } from "../notifications/NotificationsDropdown";
import { DropdownProfile } from "./DropdownProfile";

interface HeaderProps {
	sidebarOpen: boolean;
	setSidebarOpen: (open: boolean) => void;
	variant?: "default" | "v2" | "v3";
}

export function Header({
	sidebarOpen,
	setSidebarOpen,
	variant = "default",
}: HeaderProps) {
	return (
		<>
			<header
				className={`sticky top-0 before:absolute before:inset-0 before:backdrop-blur-md max-md:before:bg-white/90 dark:max-md:before:bg-gray-800/90 before:-z-10 z-30 ${variant === "v2" || variant === "v3"
					? "before:bg-white after:absolute after:h-px after:inset-x-0 after:top-full after:bg-gray-200 dark:after:bg-gray-700/60 after:-z-10"
					: "max-md:shadow-sm md:before:bg-gray-100/90 dark:md:before:bg-gray-900/90"
					} ${variant === "v2" ? "dark:before:bg-gray-800" : ""} ${variant === "v3" ? "dark:before:bg-gray-900" : ""
					}`}
			>
				<div className="px-4 sm:px-6 lg:px-8">
					<div
						className={`flex items-center justify-between h-16 ${variant === "v2" || variant === "v3"
							? ""
							: "md:border-b border-gray-200 dark:border-gray-700/60"
							}`}
					>
						{/* Header: Left side */}
						<div className="flex">
							{/* Hamburger button */}
							<button
								className={`${theme.text.muted} ${theme.text.mutedHover} md:hidden`}
								aria-controls="sidebar"
								aria-expanded={sidebarOpen}
								onClick={(e) => {
									e.stopPropagation();
									setSidebarOpen(!sidebarOpen);
								}}
							>
								<span className="sr-only">Open sidebar</span>
								<svg
									className="w-6 h-6 fill-current"
									viewBox="0 0 24 24"
									xmlns="http://www.w3.org/2000/svg"
								>
									<rect x="4" y="5" width="16" height="2" />
									<rect x="4" y="11" width="16" height="2" />
									<rect x="4" y="17" width="16" height="2" />
								</svg>
							</button>
						</div>

						{/* Header: Right side */}
						<div className="flex items-center gap-3">
							<ChitChatIcon align="right" />
							<NotificationsDropdown align="right" />
							<DropdownHelp align="right" />
							<ThemeToggle />
							{/*  Divider */}
							<hr className={`w-px h-6 ${theme.bg.tertiary} /60 border-none`} />
							<DropdownProfile align="right" />
						</div>
					</div>
				</div>
			</header>
		</>
	);
}
